import { Cell, Grid } from 'components/Grid';
import { isMobile as isMobileSelector } from 'components/Shared/responsive';
import { useSelector } from 'react-redux';
import { Ad } from 'models/Ad';
import { Ad as AdComponent } from 'components/Ad';

interface OwnProps {
  ads: Ad[];
}

export const Campaigns = ({ ads }: OwnProps) => {
  const isMobile = useSelector(isMobileSelector);
  const gutterSize = isMobile ? 'large' : 'medium';
  const gridSize = ads.length === 3 ? '3' : '2';

  return (
    <Grid
      huge={gridSize}
      desktop={gridSize}
      large={gridSize}
      tablet={gridSize}
      phone="1"
      gutters={gutterSize}
    >
      {ads.map((item, i) => (
        <Cell key={item.url}>
          <AdComponent ad={item} position={i} />
        </Cell>
      ))}
    </Grid>
  );
};
